export const extractPrice = product => {
  const presentmentPrice = product.variants.map((variant) => variant.presentmentPrices.edges[0].node)[0]; // TODO: the first for everyone
  const price = presentmentPrice.price.amount;
  const compareAtPrice = presentmentPrice.compareAtPrice ? presentmentPrice.compareAtPrice.amount : price;

  return { price, compareAtPrice };
}